import React from "react";
import styled from "styled-components";
import { hoverEffect } from "../styles";

function Earnings() {
  return (
    <EarningsCard>
      <CardContent>
        <EarningsText>TOTAL AMOUNT</EarningsText>
        <Earning>#52,992</Earning>
        <EarningsIncrease>No. Of Active Plans</EarningsIncrease>
        <Earning>4</Earning>
      </CardContent>
    </EarningsCard>
  );
}

const EarningsCard = styled.div`
  height: max-content;
  width: 100%;
  min-width: 100px;
  background: linear-gradient(to bottom right, #e6e4ff 0%, #e6e4ff 70%);
  padding: 1rem;
  border-radius: 1rem;
  margin: 3rem 0;
  color: #0a0b69;
  transition: 0.4s ease-in-out;
  &:hover {
    box-shadow: ${hoverEffect};
  }
  @media screen and (min-width: 320px) and (max-width: 768px) {
    width: 100%;
  }
`;

const CardContent = styled.div`
  margin: 1rem;
`;


const EarningsText = styled.h6`
  text-align: center;
  font-weight: bold;
  padding: 0.4rem 0;
  `;

const Earning = styled.h5`
  text-align: center;
  margin: 1rem 0;
`;

const EarningsIncrease = styled.h6`
  text-align: center;
  font-weight: normal;
  background-color: rgba(0, 0, 0, 0.2);
  padding: 0.5rem;
  border-radius: 2rem;
  margin: 2rem 0;
`;

export default Earnings;
